import { render, staticRenderFns } from "./Birthdays.vue?vue&type=template&id=c0c464d4&scoped=true&"
import script from "./Birthdays.vue?vue&type=script&lang=js&"
export * from "./Birthdays.vue?vue&type=script&lang=js&"
import style0 from "./Birthdays.vue?vue&type=style&index=0&id=c0c464d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c464d4",
  null
  
)

export default component.exports